export const formPageMock = {
  title: 'Sed ut perspiciatis unde omnis iste',
  subTitle: 'Sed ut perspiciatis unde omnis iste natus error',
  questions: [
    {
      _id: '22',
      text: 'Question 0',
      type: 'MC',
      options: [
        {
          value: 'pp'
        },
        {
          value: 'paasdp'
        },
        {
          value: 'pasdasdp'
        }
      ],
      isRequired: false,
      order: 1
    },
    {
      _id: '23',
      text: 'Question 1',
      type: 'SA',
      options: [
        {
          value: ''
        }
      ],
      isRequired: true,
      order: 1
    },
    {
      _id: '24',
      text: 'Question 2',
      type: 'SA',
      options: [
        {
          value: ''
        }
      ],
      isRequired: false,
      order: 1
    }
  ]
};
